module.exports = __webpack_public_path__ + "img/ece359d.jpg";